import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

type NoBankAccountsMessageBoxProps = {
  color: "red" | "blue";
};

const NoBankAccountsMessageBox = React.forwardRef<HTMLDivElement, NoBankAccountsMessageBoxProps>((props, ref) => {
  const { color } = props;

  return (
    <div ref={ref as React.RefObject<HTMLDivElement>} className={`message ui ${color} flex margin-bottom gap`} style={{ padding: 4 }}>
      <div className="grow1 padding">
        {RESX.BankAccount.NoBankAccountWarning}
      </div>
      <div>
        <PhosphorGearAnchor
          href={routes.bankAccount_List().absolute}
          layout="in-square"
          backgroundColor="light"
          padding="large"
        />
      </div>
    </div>
  );
});

export default NoBankAccountsMessageBox;


